import { router } from './routes';
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';
import { SafeRouterProvider } from './components/SafeRouterProvider';

export default function App() {
  return (
    <GlobalErrorBoundary>
      <SafeRouterProvider router={router} />
    </GlobalErrorBoundary>
  );
}
